
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/discounts/new",
      function () {
        return require("private-next-pages/admin/discounts/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/discounts/new"])
      });
    }
  